{
  "en": {
    "courseDetail": {
      "headers": {
        "title": "Course Detail"
      },
      "labels": {
        "course": "Online Professional Development Course",
        "webinar": "Live Webinar",
        "impulse": "Micro lesson",
        "workshop": "Workshop"
      },
      "headings": {
        "learningGoals": "Learning goals",
        "lessons": "Content",
        "recommendations": "You may also be interested in these topics",
        "feedbacks": "Reviews"
      },
      "buttons": {
        "startNextLesson": "Start next lesson",
        "startImpulse": "Start course",
        "enrollFree": "Enroll now",
        "enrollFreeGroup": "Enroll now",
        "enrollFreeSubscription": "Enroll now",
        "enrollSubscription": "Sign up for the flat rate",
        "enrollInternationalSubscription": "License fobizz",
        "orderFreeFlatrate": "Try the flat rate",
        "getStarted": "Get started",
        "downloadCertificate": "Download Certificate",
        "showMore": "Show more...",
        "bookmark": "Bookmark",
        "unbookmark": "Remove",
        "completeWebinar": "Complete webinar"
      },
      "sidebar": {
        "content": "Curriculum",
        "author": "Author",
        "feedback": "Feedback",
        "certificate": "Certificate",
        "speaker": "Speaker",
        "accessInfo": "Access info",
        "recording": "Recording",
        "documents": "Materials",
        "info": "General information",
        "navLabel": "Course navigation"
      },
      "enrollment": {
        "expired": "Your access to this course has expired",
        "expiredAt": "Your access to this course expired on {date}",
        "accessUntil": "You have access to this course until {date}.",
        "freeHint": "Free online professional development course",
        "closedHint": "Closed for enrollments",
        "vidisHint": "You cannot book this course with your {vidis} account. Please send an email to {emailLink}.",
        "paidHintFlatrate": "With a {flatrateLink} starting at {price}, you get access to all courses for one year.",
        "paidHintCoupon": "With the code {couponLink}, you can try out all courses, AI, and tools for one month without any commitment."
      },
      "webinar": {
        "startsAt": "Webinar registration information will be displayed here shortly before the meeting.",
        "startsAtFuture": "The webinar takes place on <strong>{date} from {start} to {end} {timezone}</strong>.",
        "startsAtPast": "The webinar took place on <strong>{date} from {start} to {end} {timezone}</strong>.",
        "startsAtNow": "The webinar is currently taking place from <strong>{start} to {end} {timezone}</strong>.",
        "startsAtToday": "The webinar takes place today from <strong>{start} to {end} {timezone}</strong>.",
        "startsAtTodayPast": "The webinar took place today from <strong>{start} to {end} {timezone}</strong>.",
        "recordingHint": "A recording of this event will be available.",
        "noRecording": "This event will not be recorded."
      },
      "accessInfo": {
        "recordingHintHtml": "Note: Subtitles in our videos are generated automatically, and some terms may not be perfectly recognized. If you have feedback about the subtitles, contact us at <a href=\"mailto:support{'@'}fobizz.com\" target=\"_blank\">support{'@'}fobizz.com</a>",
        "recordingPending": "The recording is still being processed. It will appear here as soon as it is available.",
        "noRecording": "There is no recording for this webinar."
      },
      "feedback": {
        "emptyHint": "This course is new. There are no reviews yet - but we are looking forward to your first feedback.",
        "carousel": {
          "previous": "Previous",
          "next": "Next"
        }
      },
      "feedbackNew": {
        "heading": "Completion and feedback",
        "complete": "Please complete all lessons to provide feedback. Thank you!",
        "existing": "You have already given feedback. Thank you very much!",
        "downloadCertificate": "Download certificate",
        "form": {
          "rating": "How would you rate this course?",
          "ratingLabels": {
            "1": "Very unsatisfying",
            "2": "Not satisfying",
            "3": "Neutral",
            "4": "Good",
            "5": "Excellent"
          },
          "recommendationScore": "How likely would you be to recommend fobizz?",
          "recommendationLow": "Unlikely",
          "recommendationHigh": "Very likely",
          "continueUsing": "Would you like to continue using fobizz?",
          "continueUsingTrue": "Yes",
          "continueUsingFalse": "No",
          "publicComment": "Your review of this course (will be visible to others)",
          "publicCommentHelp": "Maximum of 512 characters",
          "authorName": "Name to display with review (full or abbreviated)",
          "authorNameHelp": "E.g. Sarah Miller, Primary School Teacher from Illinois | S.M. Primary School Teacher from USA",
          "personalComment": "Personal feedback to the author and the fobizz team",
          "personalCommentHelp": "Maximum of 512 characters",
          "requestedTopics": "What topics would you like to see on fobizz in the near future?",
          "requestedTopicsHelp": "Maximum of 512 characters",
          "submit": "Submit and receive your certificate",
          "errors": {
            "ratingRequired": "Please select a rating.",
            "recommendationRequired": "Please select a value between 0 and 10.",
            "continueUsingRequired": "Please choose an option.",
            "personalCommentRequiredLowRating": "A personal comment is required for a low rating.",
            "maxLength": "Maximum 512 characters allowed."
          }
        }
      },
      "lesson": {
        "headers": {
          "courseContent": "Curriculum"
        },
        "links": {
          "completeAndNext": "Complete and next",
          "complete": "Complete",
          "next": "Next",
          "previous": "Previous",
          "overview": "Back to course overview"
        },
        "labels": {
          "complete": "complete"
        },
        "paragraphs": {
          "notEnrolled": "You are not yet enrolled in this course",
          "notRegistered": "Register first to continue with the course."
        },
        "blocks": {
          "download": "Download",
          "noPreview": "No preview available",
          "unsupported": "This content cannot be displayed.",
          "videoFallback": "Your browser does not support embedded videos."
        }
      },
      "recommendations": {
        "empty": "There are no recommendations at the moment.",
        "error": "Recommendations could not be loaded."
      },
      "status": {
        "headings": {
          "thanks": "Thank you for your feedback!",
          "courseIncomplete": "Course not completed",
          "courseIncompleteWebinar": "Webinar not completed",
          "nextSteps": "What's next?",
          "noFeedback": "No feedback yet?"
        },
        "paragraphs": {
          "certificate": "You will find your certificate here once you have completed the course.",
          "courseCompleted": "You completed this course.",
          "courseCompletedWebinar": "You completed this webinar.",
          "courseIncomplete": "Complete all lessons in the course to receive your certificate.",
          "courseIncompleteWebinar": "Mark the webinar as complete to receive your certificate.",
          "downloadCertificate": "Download your certificate now.",
          "materialsHtml": "Take a look at our <strong>interactive teaching materials</strong> to find something useful.",
          "certificateNotReady": "Once you complete the course, your certificate will be available here.",
          "certificateNotReadyWebinar": "Once you complete the webinar, your certificate will be available here."
        },
        "links": {
          "downloadCertificate": "Download certificate",
          "gallery": "Explore materials",
          "feedback": "Rate this course now",
          "feedbackWebinar": "Rate this webinar now"
        }
      },
      "accordion": {
        "feedbackAndCertificate": "Feedback and Certificate"
      },
      "format": {
        "title": {
          "b2bWorkshop": "School-specific & practical",
          "b2cWorkshop": "Live & Interactive",
          "webinar": "Live & Interactive",
          "impulse": "Short & Compact",
          "course": "Professional development at your own pace"
        },
        "content": {
          "b2bWorkshop": "Workshops are live webinars with an interactive workshop format. Here you'll work together with other educators on practical topics and exchange ideas within the group. Perfect for those who want to network and learn from each other.",
          "b2cWorkshop": "Workshops provide customized professional development directly at your school. Together with colleagues, you'll work on practical topics tailored to the specific needs and challenges of your institution.",
          "webinar": "Live webinars at fobizz enable a dynamic digital exchange with versatile speakers from the educational sector. Engaging presentations and exercises spark fresh insights, provoke thoughtful questions, and stimulate discussions that extend well beyond traditional classroom exchanges with colleagues. A recording of the event will often be available for those unable to attend live.",
          "impulse": "Discover new topics and lesson ideas in just 30 minutes. Our Micro lessons are designed to give you a quick and insightful learning experience. They're perfect for filling short gaps in your day with valuable knowledge. Each session, or \"Micro lesson\", includes hands-on exercises and supplemental materials to help you apply what you've learned right away. After each Micro lesson, you'll also receive personalized learning recommendations to deepen your understanding.",
          "course": "Dive deep into a wide range of topics critical to today's educators. Explore topics such as AI, digital methodologies, innovative lesson planning, and teacher wellbeing. Work at your own pace to enhance your teaching skills and personal development. Each professional development course provides actionable strategies and ideas to enrich your teaching and daily work."
        }
      }
    }
  }
}
